export const load = () => ({
	title: 'Request An Estimate For Indow Inserts',

	description:
		"We'll send you a free estimate with our best pricing to insulate your home or business with Indow Window Inserts and answer any questions about performance and installation.",
	showTitle: false,
});
